import "./index.less";

import React from "react";
import { render } from "react-dom";

import App from "./App";

class BookForm {
  constructor(divId, options) {
    const {isInCart, artistName, productType, isOrderedDigital, variants} = options;
    // const isInCart = true;
    // const artistName = "nakagawa";
    // const variants = [
    //   {
    //     id: "123456789",
    //     title: "Shikaketegami"
    //   }
    // ];
    render(
      <App isInCart={isInCart} artistName={artistName} productType={productType} variants={variants} isOrderedDigital={isOrderedDigital}/>,
      document.querySelector(`#${divId}`)
    );
  }
}

export { BookForm };
// 開発時のみ使用
if (process.env.ENV === "local") {
  console.log("src js");
  console.log("process.env.ENV: ", process.env.ENV);
  /*
  Shopify theme/sections/product-template.liquid から受け取る値を開発用に擬似的に設定
  SKU で分岐されている
  Reactに影響するのは artistName と productType で、組み合わせで何を出すか判定している
  */
  const options = {
    isInCart        : false,
    // artistName      : "momoro",
    // artistName      : "nakagawa",
    // artistName: "kanai",
    // artistName: "aoyama",
    artistName: "okuta",
    // productType     : "male_to_female", // 商品タイプ毎に変わる 「男性から女性へのシカケテガミ」
    // productType     : "parent_to_child", // 商品タイプ毎に変わる 「親から子へのシカケテガミ」
    // productType     : "female_to_male", // 商品タイプ毎に変わる 「女性から男性へのシカケテガミ」
    // productType     : "child_to_parent", // 商品タイプ毎に変わる 「子から父or母へのシカケテガミ」
    productType     : "child_to_parents", // 商品タイプ毎に変わる 「子から両親へのシカケテガミ」
    // isOrderedDigital: true,
    variants        : [{
      "id"        : "42554544783423",
      "title"     : "Default Title"
    }]
  };
  console.log({ options });
  new BookForm("app", options);
}



// WEBPACK FOOTER //
// ./src/src.js